export const URI = 


//'https://localhost:7198'
//'https://automa-mes.co.kr:8000'
'/api'
export default URI